const FILTERS_SELECTOR = '[data-filter-tag]'
const filters = document.querySelectorAll(FILTERS_SELECTOR)

function init() {

if(!filters) return

initFilters(filters)

}


function initFilters(filters){
  filters.forEach(filter => {
    filter.addEventListener('click', (e) => {
      resetElementsAttribute(filters, "aria-expanded")
      toggleAttribute(e.target, "aria-expanded")
    })
  });
}

function resetElementsAttribute(elements, attributeName){
  elements.forEach(element => {
    element.setAttribute(attributeName,'false')
  });
}

function toggleAttribute(element, attributeName) {

  const elemAttrValue = element.getAttribute(attributeName)

  if(elemAttrValue === "false"){
    element.setAttribute(attributeName,'true')
  }else{
    element.setAttribute(attributeName,'false')
  }
  
}

export default { init }